import React, { useEffect, useRef } from 'react'
import { useThrottle } from "../../hooks/hooks";

const styles = {
    width: 0,
    height: "5px",
    background: "red",
    transition: "width .2s"
  };

function ProgressBar({percentage}) {
    const elementRef = useRef(undefined);
    const updatedWidth = useThrottle(percentage, 400);

    useEffect(() => {
        if (updatedWidth) {
          updateWidth(updatedWidth);
        }
      }, [updatedWidth]);

      function updateWidth(value) {
        elementRef.current.style.width = `${value}%`;
      }
    
      return <div ref={elementRef} style={styles} />;
   
}

export default ProgressBar
